<template>
  <div class="headerMain">
    <div class="my_header fit-pc">
      <!--banner-->
      <div class="my_navbar">
        <!--logo-->
        <div class="my_logo" @click="goToPage('/home')">
          <!-- <img class="logo-tran" src="https://bosumjs.oss-accelerate.aliyuncs.com/website/logo-tran.png" alt=""> -->
          <img class="logo-tran" :src="imgList[$i18n.locale]" alt="">
          <!-- <img class="logo-gold" src="https://bosumjs.oss-accelerate.aliyuncs.com/website/logo-red.png" alt=""> -->
        </div>
        <div class="inner_navbar">
          <div class="my_menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="rgba(0, 0, 0, 0);" text-color="#fff" active-text-color="red" menu-trigger="hover" unique-opened>
              <el-menu-item index="/home">
                <a href="javascript:void(0);" @click="goToPage('/home')">{{ $t("nav.title01") }}</a>
              </el-menu-item>
              <el-submenu index="/about" popper-class="headerMain">
                <template slot="title"><span class="aboutText" @click="topClickEvent('/about')" :class='{ redColorSec: (activeIndex == "/about-duty" || activeIndex == "/about-dynamic") }'>{{ $t("nav.title02")
                    }}</span></template>
                <el-menu-item index="/about" @click="goToPage('/about', 'brief')">{{ $t("nav.title8") }}</el-menu-item>
                <el-menu-item index="/about-mission" @click="goToPage('/about', 'mission')">{{ $t("nav.title9") }}</el-menu-item>
                <el-menu-item index="/about-originator" @click="goToPage('/about', 'originator')">{{ $t("nav.title10") }}</el-menu-item>
                <el-menu-item index="/about-process" @click="goToPage('/about', 'process')">{{ $t("nav.title11") }}</el-menu-item>
                <el-menu-item index="/about-architect" @click="goToPage('/about', 'architect')">{{ $t("nav.title12") }}</el-menu-item>
                <el-menu-item index="/responsibility" @click="topClickEvent('/responsibility')">
                  {{ $t("nav.title14") }}<i class="el-icon-arrow-right iconRight"></i>
                </el-menu-item>
                <el-menu-item index="/prizes" @click="goToPage('/about', 'prizes')">{{ $t("nav.title15") }}</el-menu-item>
                <el-submenu index="/about-dynamic" popper-class="headerMain">
                  <template slot="title"><span class="secTitle" @click="goToPage('/about', 'dynamic')" :class='{ redColorSec: activeIndex == "/about-dynamic" }'>{{ $t("nav.title16") }}</span></template>
                  <el-menu-item index="/newsDynamic">
                    <span class="secTitle" @click="topClickEvent('/newsDynamic')">{{ $t("nav.title18") }}</span>
                  </el-menu-item>
                  <el-menu-item index="/industrialReport">
                    <span class="secTitle" @click="topClickEvent('/industrialReport')">{{ $t("nav.title19") }}</span>
                  </el-menu-item>
                  <el-menu-item index="/boSumPublish">
                    <span class="secTitle" @click="topClickEvent('/boSumPublish')">{{ $t("nav.title20") }}</span>
                  </el-menu-item>
                    <el-menu-item index="/courseConsultList">
                        <span class="secTitle" @click="topClickEvent('/courseConsultList')">{{ $t("nav.title42") }}</span>
                    </el-menu-item>
                </el-submenu>
              </el-submenu>
              <el-menu-item index="/teaching"><a href="javascript:void(0);" @click="goToPage('/teaching')">{{ $t("nav.title03") }}</a>
              </el-menu-item>

              <!-- 课程服务 -->
              <el-submenu index="/course" popper-class="headerMain">
                <template slot="title"><span class="aboutText" @click="topClickEvent('/course')" :class='{ redColorSec: (activeIndex == "/course-sheet") }'>{{ $t("nav.title04")
                    }}</span></template>
                <el-menu-item index="/course" style="display: none;">课程服务</el-menu-item>
                <el-menu-item index="/consult" @click="goToPage('/consult')" v-show="false">{{ $t("nav.title21") }}</el-menu-item>
                <el-menu-item index="/course-sheet" @click="goToPage('/course', 'sheet')">
                  {{ $t("nav.title23") }}
                </el-menu-item>
                <el-menu-item index="/courseServer/personalLearning">
                  <span class="secTitle" @click="topClickEvent('/courseServer/personalLearning')">{{ $t("nav.title24") }} <i class="el-icon-arrow-right iconRight"></i></span>
                </el-menu-item>
                <el-menu-item index="/courseServer/teamLearning">
                  <span class="secTitle" @click="topClickEvent('/courseServer/teamLearning')">{{ $t("nav.title25") }} <i class="el-icon-arrow-right iconRight"></i></span>
                </el-menu-item>
                <el-menu-item index="/courseServer/accompanyRunners">
                  <span class="secTitle" @click="topClickEvent('/courseServer/accompanyRunners')">{{ $t("nav.title26") }} <i class="el-icon-arrow-right iconRight"></i></span>
                </el-menu-item>
                <el-menu-item index="/courseServer/lead">
                  <span class="secTitle" @click="topClickEvent('/courseServer/lead')">{{ $t("nav.title27") }} <i class="el-icon-arrow-right iconRight"></i></span>
                </el-menu-item>
                <el-menu-item index="/courseServer/onLine">
                  <span class="secTitle" @click="topClickEvent('/courseServer/onLine')">{{ $t("nav.title28") }} <i class="el-icon-arrow-right iconRight"></i></span>
                </el-menu-item>
              </el-submenu>

              <!-- 实战导师 -->
              <el-submenu index="/combat" popper-class="headerMain">
                <template slot="title"><span class="aboutText" @click="topClickEvent('/combat')" :class='{ redColorSec: activeIndex == "/combat-introduce" }'>{{ $t("nav.title05") }}</span></template>
                <el-menu-item index="/combat" @click="goToPage('/combat', 'strength')">{{ $t("nav.title30") }}</el-menu-item>
                <el-menu-item index="/combat-combatMouth" @click="goToPage('/combat', 'combatMouth')">{{ $t("nav.title31") }}</el-menu-item>
                <el-submenu index="/combat-introduce" popper-class="headerMain">
                  <template slot="title"><span class="secTitle" @click="goToPage('/combat', 'introduce')" :class='{ redColorSec: activeIndex == "/combat-introduce" }'>{{ $t("nav.title32") }}</span></template>
                  <el-menu-item index="/fieldIInstructor">
                    <span class="secTitle" @click="topClickEvent('/fieldIInstructor')">{{ $t("nav.title33") }}</span>

                  </el-menu-item>
                </el-submenu>
              </el-submenu>
            <!-- 官网跳转 -->
            <!-- <el-menu-item index="/ai"><a href="javascript:void(0);" @click="goAiHome">{{ $t("nav.titleAi") }}</a>
            </el-menu-item> -->
              <!-- 企业学员 -->
              <el-submenu index="/student" popper-class="headerMain">
                <template slot="title">
                  <span class="aboutText" @click="topClickEvent('/student')" :class='{ redColorSec: activeIndex == "/student-outstandingAlumni" }'>{{
                    $t("nav.title06") }}</span>
                </template>
                <el-menu-item index="/student" @click="goToPage('/student', 'summarize')">{{ $t("nav.title34") }}</el-menu-item>
                <el-menu-item index="/outstandingAlumni" @click="topClickEvent('/outstandingAlumni')">
                  {{ $t("nav.title35") }}<i class="el-icon-arrow-right iconRight"></i>
                </el-menu-item>
                <el-menu-item index="/student-studentCom" @click="goToPage('/student', 'studentCom')">{{ $t("nav.title37") }}</el-menu-item>
                <el-menu-item index="/student-resource" @click="goToPage('/student', 'resource')">{{ $t("nav.title38") }}</el-menu-item>
              </el-submenu>

              <!--  加入博商 -->
              <!-- <el-submenu index="/join" popper-class="headerMain">
                <template slot="title">
                  <span class="aboutText" @click="topClickEvent('/join')">{{
                    $t("nav.title07") }}</span>
                </template>
                <el-menu-item index="/join" @click="goToPage('/join', 'advantage')">{{ $t("nav.title39") }}</el-menu-item>
                <el-menu-item index="/join-BSstrength" @click="goToPage('/join', 'teacherCoop')">{{ $t("nav.title40") }}</el-menu-item>
                <el-menu-item index="/join-teacherCoop" @click="goToPage('/join', 'teacherCoop')">{{ $t("nav.title41") }}</el-menu-item>
              </el-submenu> -->
              <!--  加入博商 -->
              <el-submenu index="/recruit" popper-class="headerMain">
                <template slot="title">
                  <span class="aboutText" @click="topClickEvent('/recruit')">{{
                    $t("nav.title07") }}</span>
                </template>
                <el-menu-item index="/recruit" style="display: none;">加入博商</el-menu-item>
                <!-- <el-menu-item index="/join" @click="goToPage('/join', 'advantage')">{{ $t("nav.title39") }}</el-menu-item> -->

                <a :href="`${RECRUIT_PATH}/#/WCampusIntroduce`" target="_blank" rel="noopener noreferrer">
                  <el-menu-item index="/jobXncom">{{ $t('recruit.recruitText1') }}</el-menu-item>
                </a>

                <a :href="`${RECRUIT_PATH}/#/WSocialIntroduce`" target="_blank" rel="noopener noreferrer">
                  <el-menu-item index="/socialRecruitment">{{ $t('recruit.recruitText2') }}</el-menu-item>
                </a>

                <a :href="`${RECRUIT_PATH}/#/WTeacherRecruitment`" target="_blank" rel="noopener noreferrer">
                  <el-menu-item index="/teacherRecruitment">{{ $t('recruit.recruitText3') }}</el-menu-item>
                </a>
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <ul class="langSty">
          <li class="singleLang" @click="handleCommand('to-zh')" :class="{ singleLangSec: $i18n.locale == 'zh-cn' }">CN</li>
          <li class="singleLang" @click="handleCommand('to-en')" :class="{ singleLangSec: $i18n.locale == 'en' }">EN</li>
          <li class="singleLang" @click="handleCommand('to-ja')" :class="{ singleLangSec: $i18n.locale == 'ja' }">JP</li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import '@/assets/styles/pages/navbar.scss'
import $ from 'jquery'
import Common from '@/js/common.js'
const RECRUIT_PATH = process.env.RECRUIT_PATH
export default {
  name: "myHeader",
  data: function () {
    return {
      RECRUIT_PATH: RECRUIT_PATH,
      activeIndex: '/home',
      currentLang: '中文',
      drawer: false,
      direction: 'ltr',
      imgList: {
        en: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/bosumEN104_30SVG.svg",
        ja: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/bosumEN104_30SVG.svg",
        "zh-cn": "https://bosumjs.oss-accelerate.aliyuncs.com/website/logo-tran.png",
      },
    }
  },
  watch: {
    $route(to, from) {
      if (this.$store.state.commentId && this.$store.state.commentId != "brief" && this.$store.state.commentId != "courseBright" && this.$store.state.commentId != "strength" && this.$store.state.commentId != "summarize" && this.$store.state.commentId != "advantage") {
        this.activeIndex = to.path + "-" + this.$store.state.commentId
      } else {
        this.activeIndex = to.path

      }
      console.log(' this.activeIndex', this.activeIndex)
    }
  },
  mounted: function () {
    var vm = this;
    Common.Utils.showMobileElem();
    if (localStorage.getItem('lang')) {
      localStorage.lang = localStorage.getItem('lang')
      if (localStorage.lang) {
        vm.currentLang = localStorage.lang == 'en' ? 'English' : '中文';

        if (localStorage.lang == 'zh-cn') {
          document.title = "博商管理科学研究院"
        } else if (localStorage.lang == 'ja') {
          document.title = "博商管理科学研究院"
        } else {
          document.title = "Bosum Institute of Management Science"
        }
      }
    }
    else {
      // vm.handleCommand('to-en')

      // if (localStorage.lang) {
      //   vm.currentLang = localStorage.lang == 'en' ? 'English' : '中文';
      // }
      //获取所在国家
      fetch("https://ipinfo.io?token=90739443e1c192")
        .then((response) => response.json())
        .then((data) => {
          const country = data.country;
          console.log("用户所在国家：", country);
          // console.log("用户所在地区：", region);
          if (country == 'CN') {
            vm.handleCommand('to-zh')
          } else if (country == 'JP') {
            vm.handleCommand('to-ja')
          } else {
            vm.handleCommand('to-en')
          }

          if (localStorage.lang) {
            vm.currentLang = localStorage.lang == 'en' ? 'English' : '中文';
          }
        }).catch((error) => {
          console.error("获取国家和地区信息时出错：", error);
          if (localStorage.lang) {
            vm.currentLang = localStorage.lang == 'en' ? 'English' : '中文';
          }
        });
    }

  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  methods: {
    goToTargetPage: function () {
      //判断是否登录过
      var vm = this;
      var isLogin = sessionStorage.getItem('bosumLogin');
      if (!Common.Utils.isEmpty(isLogin) && isLogin == 'Y') {
        vm.$router.push('student');
      } else {
        vm.$router.push('login');
      }
    },
    goAiHome(){
      window.open('https://bosumai.com', '_blank')
    },
    handleCommand: function (cmd) {
      var vm = this;
      var handCmd = {
        "to-zh": "changeToZh",
        "to-en": "changeToEn",
        "to-ja": "changeToJa"
      };
      vm[handCmd[cmd]]();
      console.log('cmd', cmd)
      if (cmd == 'to-zh') {
        document.title = "博商管理科学研究院"
      } else if (cmd == 'to-ja') {
        document.title = "博商管理科学研究院"
      } else {
        document.title = "Bosum Institute of Management Science"
      }
    },
    changeToZh: function () {
      var vm = this;
      vm.changeLanguage('zh-cn');
      vm.currentLang = '中文';
    },
    changeToEn: function () {
      var vm = this;
      vm.changeLanguage('en');
      vm.currentLang = 'English';
    },
    changeToJa: function () {
      var vm = this;
      vm.changeLanguage('ja');
      vm.currentLang = '日文';
    },
    //切换语言
    changeLanguage: function (language) {
      //本地语言开关切换
      this.$i18n.locale = language;
      //设置本地存储
      localStorage.setItem("lang", language);
      this.$store.state.currentLang = language;
    },
    changeLanguageMobile: function () {
      var vm = this;
      if (vm.currentLang == '中文') {
        vm.changeToEn();
      } else {
        vm.changeToZh();
      }
    },
    topClickEvent(path) {
      this.goToPage(path)
    },

    goToPage: function (path, commentId) {
      this.$store.commit('SET_COMMENT_ID', commentId);
      var vm = this;

      if (this.$route.path == path && this.$store.state.commentId != "brief" && this.$store.state.commentId != "courseBright" && this.$store.state.commentId != "strength" && this.$store.state.commentId != "summarize" && this.$store.state.commentId != "advantage") {
        if (this.$store.state.commentId) {
          this.activeIndex = this.$route.path + "-" + this.$store.state.commentId
        }
        return
      } else {
        this.activeIndex = path
      }
      console.log('this.activeIndex =', this.activeIndex)
      vm.$router.push({
        path: path,

      });
      vm.drawer = false;
    },
    handleSelect: function (key, keyPath) {
      console.log("handleSelect", key, keyPath);
    },
  }
}
</script>
<style lang="scss">
.headerMain {


  .el-menu--popup-bottom-start {
    background: rgba(0, 0, 0, 0.7) !important;
  }

  .el-menu-item,
  .el-submenu__title {
    background-color: rgba(0, 0, 0, 0) !important;

    &:hover {
      color: red !important;
      background: rgba(0, 0, 0, 0.4) !important;

      .iconRight {
        color: #D31319;
      }
    }
  }

  .redColorSec {
    color: red;
  }

  .el-menu--popup-right-start {
    background: rgba(0, 0, 0, 0.7) !important;

    &:hover {
      color: red !important;
      background: rgba(0, 0, 0, 0.4) !important;

      .iconRight {
        color: #D31319;
      }
    }
  }
}

.headerMainActive {

  // 子菜单
  .el-menu--popup-bottom-start {
    background: rgba(0, 0, 0, 0.7) !important;
  }

  .el-menu-item,
  .el-submenu__title {
    background-color: rgba(0, 0, 0, 0) !important;

    &:hover {
      color: red !important;
      background: rgba(0, 0, 0, 0.4) !important;

      .iconRight {
        color: #D31319;
      }
    }
  }

  .redColorSec {
    color: red;
  }

  .el-menu--popup-right-start {
    background: rgba(0, 0, 0, 0.7) !important;

    &:hover {
      color: red !important;
      background: rgba(0, 0, 0, 0.4) !important;

      .iconRight {
        color: #D31319;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.my_header {
  border-bottom: 1px rgba(255, 255, 255, 0.5) solid;
}

.my_navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width:1500px;
  margin:0 auto;
//   border:1px solid red;

}

.aboutText {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
}

.secTitle {
  display: inline-block;
  font-size: 14px;
  width: 100%;
}

.langSty {
  display: inline-block;
  width:145px;
  .singleLang {
    display: inline-block;
    width: 38px;
    height: 18px;
    // background: #D31319;
    border-radius: 9px;
    line-height: 18px;
    text-align: center;
    // background-color: #ccc;

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    cursor: pointer;
  }

  .singleLangSec {
    background: #D31319;
  }
}

.iconRight {
  float: right;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue